import { render, staticRenderFns } from "./listaLocal.vue?vue&type=template&id=bdcad102&scoped=true"
import script from "./listaLocal.vue?vue&type=script&lang=js"
export * from "./listaLocal.vue?vue&type=script&lang=js"
import style0 from "./listaLocal.vue?vue&type=style&index=0&id=bdcad102&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcad102",
  null
  
)

export default component.exports